import styled from "styled-components";

export const Main = styled.header`
	grid-area: header;
	padding: 0 1.6rem;
	z-index: 10;
	min-width: 0;
`;

export const Container = styled.div`
	min-height: 65px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.6rem 0;
	gap: 2rem;

	border-bottom: 1px solid ${({ theme }) => theme.colors.itemBorder};
`;

export const HeaderLabel = styled.div`
	font-weight: 500;
	color: ${({ theme }) => theme.colors.textPrimary};
	white-space: nowrap;
`;

export const InlineSearchInput = styled.input`
	width: 100%;
	max-width: 280px;
	padding: 10px 14px;
	border: 1px solid ${({ theme }) => theme.colors.inputBorder};
	border-radius: 4px;
	font-size: 1.4rem;
	color: ${({ theme }) => theme.colors.textPrimary};

	&::placeholder {
		color: ${({ theme }) => theme.colors.inputPlaceholder};
	}

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.colors.lightOrange};
	}
`;

export const Form = styled.form`
	display: flex;
	gap: 1.2rem;
	align-items: center;
	min-width: 0;
`;

export const ButtonContainer = styled.div`
	display: flex;
	gap: 1.2rem;
	align-items: center;
`;

export const FilterButton = styled.div`
	display: flex;
	gap: 0.4rem;
	align-items: center;
	justify-content: center;
`;

export const InputWrapper = styled.div<{ $showType: string; $name?: string; $width?: string }>`
    width: ${({ $showType, $name, $width }) => {
        if ($width) return `${$width} !important`;
        if ($name === "search") return "300px !important"; // Make search wider
        if ($name === "companyId" || $name === "companyIds") return "200px";
       if ($name === "categoryId") return "200px";
        if ($showType === "select") return "168px";
        return "126px";
    }};
`;
